const $ = jQuery;

import * as News from './views/News';
import * as Events from './views/Events';

$(function() {
    let $body = $('body');

    /**
     * Handle AJAX loading on the news page
     */
    if ($body.hasClass('blog')) {
        let $ajaxLoadTrigger = $('.post-loader .load-posts');

        if ($ajaxLoadTrigger.length) {
            News.bindAjaxLoader($ajaxLoadTrigger);
        }
    }

    /**
     * Apply filters on the events archive
     */
    if ($body.hasClass('post-type-archive-event')) {
        let $form = $('.event-filters .filter form');

        Events.setPageScrollPosition('.event-content');

        if ($form.length) {
            Events.setForm($form);
            Events.bindCategoryFilters('.apply-filters');
            Events.bindDateFilter('#event-date');
            Events.bindMobileFilter('.mobile-trigger');
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/router.js